// app/javascript/controllers/catalogo_controller.js
import { Controller } from "stimulus"
import Hammer from "hammerjs"
import $ from "jquery"

export default class extends Controller {
    static targets = ["galeria"]

    connect() {
        this.imagenes = []
        this.indexActual = 0

        // transform state
        this.zoom = 1
        this.maxZoom = 3
        this.minZoom = 1
        this.posX = 0
        this.posY = 0

        // helpers para pan/pinch
        this._hammer = null
        this._pinchStartZoom = 1
        this._panStartX = 0
        this._panStartY = 0
        this._posXBeforePan = 0
        this._posYBeforePan = 0

        this.cargarImagenes()

        // inicializar eventos globales (pero no hammer todavía)
        this.inicializarEventosLightbox()
        this.inicializarEventosTeclado()

        // inicializar al mostrar/ocultar modal para (re)crear hammer y miniaturas
        $("#lightboxModal").on("shown.bs.modal", () => {
            this.inicializarHammer()    // crea/attach Hammer sobre la imagen visible
        })

        $("#lightboxModal").on("hidden.bs.modal", () => {
            this.destruirHammer()
        })
    }

    // --------------------------
    // 1) Cargar galería
    // --------------------------
    cargarImagenes() {
        fetch("/admin/media_galeries/gallery")
            .then(res => res.json())
            .then(data => {
                let imagenes = data.map(item => item.img).filter(url => url)
                let descripciones = data.map(item => item.description)
                this.generarGaleriaHTML(imagenes, descripciones)
            })
    }

    generarGaleriaHTML(imagenes, descripciones) {
        this.imagenes = imagenes
        this.descripciones = descripciones

        if (!this.hasGaleriaTarget) return

        let html = ""
        imagenes.forEach((src, i) => {
            html += `
                    <div class="masonry-item">
                        <img src="${src}"
                            class="img-galeria"
                            data-index="${i}"
                            loading="lazy"
                            alt="Imagen ${i + 1}">
                    </div>
                    `
        })

        this.galeriaTarget.innerHTML = html

        $(".img-galeria").on("click", e => {
            this.indexActual = parseInt($(e.target).data("index"))
            this.abrirLightbox()
        })
    }

    // --------------------------
    // 2) Lightbox open / load image
    // --------------------------
    abrirLightbox() {
        this.cargarImagenEnLightbox()
        this.generarMiniaturas()
        $("#lightboxModal").modal("show")
    }

    cargarImagenEnLightbox() {
        const img = $("#lightboxImg")
        const desc = $("#lightboxDesc")

        img.attr("src", this.imagenes[this.indexActual])
        desc[0].innerHTML = this.descripciones[this.indexActual]

        // reset transform state
        this.zoom = 1
        this.posX = 0
        this.posY = 0
        this._posXBeforePan = 0
        this._posYBeforePan = 0
        this.aplicarTransformacion()

        // actualizar contador (ej: 3 / 10)
        $("#lightboxCounter").text(`${this.indexActual + 1} / ${this.imagenes.length}`)
    }

    // --------------------------
    // 3) Miniaturas
    // --------------------------
    generarMiniaturas() {
        const cont = $("#lightboxThumbnails")
        cont.html("")

        this.imagenes.forEach((src, i) => {
            cont.append(`
                        <img src="${src}"
                            data-idx="${i}"
                            style="height:65px; cursor:pointer; border-radius:4px; margin-right:8px; object-fit:cover;"
                            class="thumb-small">
                        `)
        })

        // click en miniaturas
        $(".thumb-small").on("click", e => {
            this.indexActual = parseInt($(e.target).data("idx"))
            this.cargarImagenEnLightbox()
        })
    }

    // --------------------------
    // 4) Prev / Next
    // --------------------------
    inicializarEventosLightbox() {
        $("#nextImg").on("click", () => {
            this.indexActual = (this.indexActual + 1) % this.imagenes.length
            this.cargarImagenEnLightbox()
        })

        $("#prevImg").on("click", () => {
            this.indexActual = (this.indexActual - 1 + this.imagenes.length) % this.imagenes.length
            this.cargarImagenEnLightbox()
        })

        // fullscreen toggle
        $("#fullscreenBtn").on("click", () => {
            this.toggleFullscreen()
        })

        // si quieren cerrar con ESC (bootstrap hace eso por defecto), pero nos aseguramos de resetear transforms
        $("#lightboxModal").on("hidden.bs.modal", () => {
            this.zoom = 1
            this.posX = 0
            this.posY = 0
            this.aplicarTransformacion()
        })

        // ⬇⬇⬇ AQUI VA EL FULLSCREEN RESET ⬇⬇⬇
        /*document.addEventListener("fullscreenchange", () => {
            if (document.fullscreenElement) {
                this.zoom = 1
                this.posX = 0
                this.posY = 0
                this.aplicarTransformacion()
            }
        })*/

        const onFullScreenChange = () => {
            if (document.fullscreenElement) {
                // al entrar en fullscreen: reset transforms (opcional)
                this.zoom = 1
                this.posX = 0
                this.posY = 0
                this.aplicarTransformacion()
                $("#fullscreenBtn").addClass("active")
                $("#lightboxImg").parent().addClass("lightboxModal-full")
                $("#lightboxImg").addClass("lightboxImg-full")
                $("#lightboxDesc").addClass("lightboxDesc-full")
                $("#divlightboxDesc").addClass("divlightboxDesc-full")
            } else {
                // al salir de fullscreen (ESC o exit): limpiar clases y estado
                this.zoom = 1
                this.posX = 0
                this.posY = 0
                this.aplicarTransformacion()
                $("#fullscreenBtn").removeClass("active")
                $("#lightboxImg").parent().removeClass("lightboxModal-full")
                $("#lightboxImg").removeClass("lightboxImg-full")
                $("#lightboxDesc").removeClass("lightboxDesc-full")
                $("#divlightboxDesc").removeClass("divlightboxDesc-full")
            }
        }

        document.addEventListener("fullscreenchange", onFullScreenChange)
        // prefijos para navegadores que los necesiten
        document.addEventListener("webkitfullscreenchange", onFullScreenChange)
        document.addEventListener("mozfullscreenchange", onFullScreenChange)
        document.addEventListener("MSFullscreenChange", onFullScreenChange)
    }

    // --------------------------
    // 5) Teclado ← →
    // --------------------------
    inicializarEventosTeclado() {
        document.addEventListener("keydown", e => {
            if (!$("#lightboxModal").hasClass("show")) return

            if (e.key === "ArrowRight") {
                $("#nextImg").click()
            }

            if (e.key === "ArrowLeft") {
                $("#prevImg").click()
            }

            // F para fullscreen
            if (e.key.toLowerCase() === "f") {
                this.toggleFullscreen()
            }
        })
    }

    // --------------------------
    // 6) Hammer (pinch + pan + doubletap) - init & destroy
    // --------------------------
    inicializarHammer() {
        // destruir si existe (para evitar duplicados)
        this.destruirHammer()

        const imgElement = document.getElementById("lightboxImg")
        if (!imgElement) return

        // crear manager
        const manager = new Hammer.Manager(imgElement)

        const pinch = new Hammer.Pinch()
        const pan = new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 })
        const doubleTap = new Hammer.Tap({ event: "doubletap", taps: 2 })
        const singleTap = new Hammer.Tap({ event: "singletap" })

        // reconocer pinch junto con pan
        pinch.recognizeWith(pan)
        doubleTap.recognizeWith(singleTap)

        manager.add([pinch, pan, doubleTap, singleTap])

        // handlers
        manager.on("pinchstart", (ev) => {
            this._pinchStartZoom = this.zoom
        })

        manager.on("pinchmove", (ev) => {
            // ev.scale es relativo al inicio del gesto
            let nuevoZoom = this._pinchStartZoom * ev.scale
            this.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, nuevoZoom))
            this.aplicarTransformacion()
        })

        manager.on("pinchend", () => {
            this.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoom))
            if (this.zoom === 1) {
                // reset position si vuelve a 1
                this.posX = 0
                this.posY = 0
                this._posXBeforePan = 0
                this._posYBeforePan = 0
                this.aplicarTransformacion()
            }
        })

        // pan (drag) - solo mover si zoom > 1
        manager.on("panstart", (ev) => {
            this._panStartX = ev.deltaX
            this._panStartY = ev.deltaY
            this._posXBeforePan = this.posX
            this._posYBeforePan = this.posY
        })

        manager.on("panmove", (ev) => {
            if (this.zoom > 1) {
                // aplicar desplazamiento relativo al inicio del pan
                this.posX = this._posXBeforePan + ev.deltaX
                this.posY = this._posYBeforePan + ev.deltaY
                this.aplicarTransformacion()
            }
        })

        manager.on("panend", () => {
            // guardamos la posición final
            this._posXBeforePan = this.posX
            this._posYBeforePan = this.posY
        })

        // doubletap para hacer zoom rápido (toggle entre 1 y 2x)
        manager.on("doubletap", () => {
            if (this.zoom > 1.1) {
                this.zoom = 1
                this.posX = 0
                this.posY = 0
            } else {
                this.zoom = Math.min(2, this.maxZoom)
            }
            this.aplicarTransformacion()
        })

        // opcional: single tap para ocultar/mostrar controles (no implementado UI hide)
        // manager.on("singletap", () => { ... })

        // guardar referencia
        this._hammer = manager
    }

    destruirHammer() {
        if (this._hammer) {
            try {
                this._hammer.stop()
                this._hammer.destroy()
            } catch (e) { /* ignore */ }
            this._hammer = null
        }
    }

    // --------------------------
    // 7) Aplicar transform al <img>
    // --------------------------
    aplicarTransformacion() {
        // límite simple para que la imagen no se salga demasiado (puedes ajustarlo)
        const maxPan = 3000 // no estrictamente usado ahora pero por si quieres clamp
        $("#lightboxImg").css(
            "transform",
            `translate(${this.posX}px, ${this.posY}px) scale(${this.zoom})`
        )
    }

    // --------------------------
    // 8) Fullscreen (Fullscreen API)
    // --------------------------
    async toggleFullscreen() {
        const modalContent = document.querySelector("#lightboxModal .modal-content")
        if (!modalContent) return

        if (!document.fullscreenElement) {
            try {
                await modalContent.requestFullscreen()
                $("#fullscreenBtn").addClass("active")
                $("#lightboxImg").parent().addClass("lightboxModal-full")
                $("#lightboxImg").addClass("lightboxImg-full")
            } catch (err) {
                console.warn("Fullscreen failed", err)
            }
        } else {
            try {
                await document.exitFullscreen()
                $("#fullscreenBtn").removeClass("active")
                $("#lightboxImg").parent().removeClass("lightboxModal-full")
                $("#lightboxImg").removeClass("lightboxImg-full")
            } catch (err) {
                console.warn("Exit fullscreen failed", err)
            }
        }
    }
}
